<script type="text/jsx" lang="jsx">
import BuyNow from './buy-now';
import Edit from "./edit.vue";
import EditDelta from "./edit-delta.vue";
import Add from "./add2cart";
import Upgrade from './upgrade.vue';
import Pbx2prop from './pbx2prop.vue';
import Downgrade from './downgrade.vue';
import Upsell from './upsell.vue';
import { mapGetters } from 'vuex';

export default {
  props: {
    configPlanTileStatus: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    ...mapGetters(['migratePlanState']),
  },
  render() {
    const context = {
      ...this.$props,
      ...this.$attrs,
    };
    if (this.$context.is.buyNow || this.$context.is.basic2pro) return <BuyNow {...context} />;
    if (this.$context.is.modalDelta) return <EditDelta {...context} />;
    if (this.$context.is.edit || this.migratePlanState.is.upgrade || this.$context.is.downgrade) {
      if (this.migratePlanState.is.upgrade) return <Upgrade {...context} />;
      if (this.migratePlanState.is.downgrade || this.$context.is.downgrade) return <Downgrade {...context} />;
      return <Edit {...context} />;
    }
    if (this.$context.is.pbx2prop) return <Pbx2prop {...context} />;
    if (this.$context.is.add2cart) return <Add {...context} />;
    if (this.$context.is.upsell) return <Upsell {...context} />;
    return null;
  },
};
</script>
